// eslint-disable-next-line import/prefer-default-export
export function parseParamsForURL(paramsObj) {
    // eslint-disable-next-line no-unused-vars
    return Object.entries(paramsObj).filter(([_, paramValue]) => paramValue !== undefined)
        .map(([paramName, paramValue]) => `${paramName}=${encodeURIComponent(paramValue)}`).join('&');
}
